export default __webpack_public_path__ + "locales/sr-Latn-RS/Profile.json?hash=fe7900c1b5dbaba55efa3522b793ed76";